import React from "react";
import { Tabs, Tab } from 'react-bootstrap';
import TabTitle from '../tabs/tab-title';
import TabDetails from '../tabs/tab-content';

function TabsContainerItems(props) {
    const items = props.itemsBox;
    const itemsDetails = items.map(( item, index ) =>
        // Key should be specified inside the array.
            <Tab
                key={ index.toString() }
                title= { <TabTitle title={ item.tabName}  icon={ item.tabIcon}/> }
                eventKey={ index + 1 } bsClass="asd">
                <TabDetails content = { item.tabContent } />
            </Tab>
    );
    return (
        <Tabs defaultActiveKey={1} className="gtco-tabs" id="gtco-tabs">
            { itemsDetails }
        </Tabs>
    );
}

export default class TabsElement extends React.Component {
    render() {
        return (
            <TabsContainerItems itemsBox={ this.props.tabData }/>
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/tabs/tabs.jsx